import { advertisingErrorMessage, isFlagOff } from '@/features/analytics/advertising/errors'
import { ApiError } from '@/lib/api'

/**
 * The `advertising_meta` flag off: a `404 not_found`. The overview takes a website,
 * so a `404 tenant_scope_error` (a website that is not this tenant's, from a stale
 * link) is a refusal of the filter, never "not enabled" (`advertising_overview/README.md`).
 */
export function isAdvertisingFlagOff(error: unknown): boolean {
  return isFlagOff(error) && (error as ApiError).code === 'not_found'
}

function reason(error: ApiError): string | null {
  const value = error.details.reason
  return typeof value === 'string' ? value : null
}

/** A section's failure in words a person can act on; never the server's own text. */
export function advertisingSectionError(error: unknown, fallback: string): string {
  if (error instanceof ApiError) {
    if (error.status === 404 && error.code === 'tenant_scope_error') {
      return 'The website in the filter bar is not one of this workspace’s websites. Clear the website filter.'
    }
    if (error.status === 403 && reason(error) === 'website_suspended') {
      return 'The website in the filter bar is suspended, so its figures cannot be shown. An Owner can contact TmT support.'
    }
    if (error.status === 422) {
      return 'These filters could not be read. Choose a range of at most 400 days, and a website in the selected environments.'
    }
    if (error.status === 503) {
      return 'A currency rate behind these figures is not available, so they are not shown rather than guessed. Try again after the next import.'
    }
  }
  return advertisingErrorMessage(error, fallback)
}
